export default "__VITE_ASSET__rT60b6RP__"